export default "__VITE_ASSET__100788c7__"